/**
 * Performs a synchronized application logout by clearing the Apollo cache, killing the
 * Keycloak session, and broadcasting a logout message to other tabs via a BroadcastChannel.
 * 
 * @param {any} client - The Apollo GraphQL client instance, used to clear the local store cache.
 * @param {any} keycloak - The initialized keycloak-js instance, used to terminate the server-side session.
 * @returns {void}
 */
import { authChannel, clearAuthSource } from './authSource';

export const performLogout = (client: any, keycloak: any): void => {
  // Broadcast logout event to other tabs using the unified object format { type: 'logout' }
  // This ensures all open tabs instantly kill the session and redirect to login, preventing race conditions.
  if (typeof BroadcastChannel !== 'undefined') {
    const logoutChannel = new BroadcastChannel(authChannel);
    logoutChannel.postMessage({ type: 'logout' });
    logoutChannel.close();
  }

  // Clear Apollo cache
  if (client && typeof client.resetStore === 'function') {
    client.resetStore();
  }

  // Navigate to Keycloak to kill the session
  if (keycloak && typeof keycloak.logout === 'function') {
    clearAuthSource();
    keycloak.logout();
  }
};
